import React from 'react'
import { useState, useEffect } from 'react'
import ImageIcon from '@material-ui/icons/Image';
import BackupIcon from '@material-ui/icons/Backup';
import HashLoader from "react-loader-spinner";

const Logo = ({ logo }) => {
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");

  const[chooseimg ,setchooseimg] = useState(false);
  // ------------------
  const [loading, setloading] = useState(false);
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
  }, [])


  // ------------
  const uploadImage = () => {

    // -----
    const data = new FormData()
    data.append("file", image)
    data.append("upload_preset", "tutorial")
    data.append("cloud_name", "dlkpq3es")
    fetch("https://api.cloudinary.com/v1_1/dlkpql3es/image/upload", {
      method: "post",
      body: data
    })
      .then(resp => resp.json())
      .then(data => {
        setUrl(data.url)
        logo(data.url);
      })
      .catch(err => alert("Check your network failed to upload logo"))
      
      
    
  }
  // -------------uploadImg------------>
  console.log(url)
  const choose=()=>{
    setTimeout(() => {
      setchooseimg(true);
    }, 
    4000);
  }
  return (
    <>
      <div>
        <div className="choose_file">
          <input onClick={choose} style={{ display: "none" }} type="file" id="file" accept='.jpg ,.png' onChange={(e) => setImage(e.target.files[0])}></input> <br />
          <label for="file">
            <ImageIcon  style={{ color: "#3d31a7" }} />
            Choose logo
          </label>
          <div className="logo_btn" style={{display:chooseimg ? "block":"none"}}>
            <button onClick={uploadImage}><BackupIcon style={{ color: "blue" }} /> upload logo</button> 
          </div>
        </div>
      </div>

    </>

  );
}

export default Logo
